/**
 * Ett litet ikonark för de ikoner som upprepas många gånger på samma sida
 * (varje annonskort har fyra stycken). I stället för att rita ut hela
 * SVG-koden per kort ritas formerna en gång i dokumentet och återanvänds med
 * <use>. Det kapar tiotals kilobyte HTML på listsidorna.
 */

export type SpriteIconName = "map-pin" | "calendar-days" | "heart" | "share-2";

/** Ritas en gång, längst upp i sidan. Syns inte men går att peka på. */
export function IconSpriteDefs() {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}
    >
      <symbol id="i-map-pin" viewBox="0 0 24 24">
        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
        <circle cx="12" cy="10" r="3" />
      </symbol>
      <symbol id="i-calendar-days" viewBox="0 0 24 24">
        <path d="M8 2v4" />
        <path d="M16 2v4" />
        <rect width="18" height="18" x="3" y="4" rx="2" />
        <path d="M3 10h18" />
        <path d="M8 14h.01" />
        <path d="M12 14h.01" />
        <path d="M16 14h.01" />
        <path d="M8 18h.01" />
        <path d="M12 18h.01" />
        <path d="M16 18h.01" />
      </symbol>
      <symbol id="i-heart" viewBox="0 0 24 24">
        <path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 0L5 15c-1.5-1.5-3-3.2-3-5.5" />
      </symbol>
      <symbol id="i-share-2" viewBox="0 0 24 24">
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
        <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
      </symbol>
    </svg>
  );
}

/** Samma utseende som lucide-ikonerna, men bara en referens i HTML:en. */
export function SpriteIcon({
  name,
  className,
  strokeWidth = 2,
}: {
  name: SpriteIconName;
  className?: string;
  strokeWidth?: number;
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <use href={`#i-${name}`} />
    </svg>
  );
}
